/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

/* TODO: To refactor (import from App/Contracts). */
import { Decimal as IDecimal, ICustomDate } from "@Internal/Contracts";
import { Recurrence } from "../Misc";
import BaseModel from "../Model";
import BasePlan from "../Plan";
import BaseProduct from "../Product";

export default interface BaseSubscriptionLine extends BaseModel {
    Name?: string;
    Quantity: IDecimal;
    Subtotal: IDecimal;
    /* Id of the frozen PriceVersion this line bills (grandfathering). When set, the line's billing
       spec is resolved from that snapshot instead of the live catalogue price. */
    PriceVersionId?: number;
    Archive?: boolean;
    ArchiveDate?: ICustomDate;
    /* Used object count for the line's price target, hydrated at runtime from the
       /console/object-limits endpoint (GroupTargetLines). Not persisted. */
    Quota?: number;
}

export interface BaseSubscriptionGroupedLines {
    Product: BaseProduct,
    Plan?: BasePlan,
    Recurrence?: Recurrence,
    Group: BaseSubscriptionLine[],
    Subtotal: IDecimal,
    Description?: string
}
